import React from "react";
import { ClientProfileSection } from "@/features/request-client-profile";
import { OrderClientProfileSummary } from "../types";

type OrderClientCellProps = {
  order: {
    client?: { name?: string };
    clientProfile?: OrderClientProfileSummary | null;
  };
};

export const OrderClientCell: React.FC<OrderClientCellProps> = ({ order }) => (
  <ClientProfileSection
    order={order}
    slot="RowSummary"
    fallback={<span className="-capitalize">{order.client?.name}</span>}
  />
);
